module.exports = __webpack_public_path__ + "img/calender-check.77c84c8b.svg";